import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import get from 'lodash/get'
import {Post} from "../../Interfaces/Post.interface";
import SimpleButton from "../Atoms/SimpleButton";
import ImageSelectionAndCropper from "../Organisms/ImageSelectionAndCropper";


interface Props {
    handleClose: () => void,
    handleSave: (obj: {imageURL:any, text: string}) => void,
    open: boolean,
    updateMode?: true
    title: string
    post?: Post
}
export default function MomentCreateOrUpdate({ handleClose, handleSave, open, title, updateMode, post }: Props) {
    const content = get(post, 'content', undefined)
    const description = get(post, 'description', '')

    const [image, setImage] = useState<string | undefined>(undefined);
    const [imageError, setImageError] = useState(false);
    const [text, setText] = useState('');
    React.useEffect(()=>{
        if(content) setImage(content)
        if(description) setText(description)
    }, [content, description])

    const useStyles = makeStyles(theme => ({
        formControl: {
            margin: theme.spacing(1),
        },
        input: {
            display: 'none',
        },
    }));
    const handleFileSelect = (res: any) => {
        let img = res;
        setImage(img);
    };

    const handleCreate = () => {
        if (!image) {
            setImageError(true);
            return false;
        }
        handleSave({ imageURL: image, text });
        setImage(undefined);
    };
    const classes = useStyles();

    return (
        <div>
            <Dialog aria-labelledby="form-dialog-title" onClose={handleClose} open={open}>
                <DialogTitle id="form-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Your post will be visible to all users who have logged in to the event.
                    </DialogContentText>
                    {image && <img alt="Moment" src={image} width={300} />}
                    <FormControl className={classes.formControl} error={imageError}>
                        <ImageSelectionAndCropper
                            postSelectionButtonText={'Use Image'}
                            handleFileSelection={handleFileSelect}
                            aspectRatio={1}
                            launchBrowserButtonText={'Add Image'}

                            recommended={{width:1024, height:1024}}/>

                        <FormHelperText id="component-error-text">
                            Please upload an image that is 1024px x 1024px
                        </FormHelperText>
                    </FormControl>

                    <TextField
                        defaultValue={text}
                        autoFocus
                        fullWidth
                        id="message"
                        label="Enter your message"
                        margin="dense"
                        onChange={evt => setText(evt.target.value)}
                        type="text"
                    />
                </DialogContent>
                <DialogActions>
                    <SimpleButton variant={'outlined'} label={'Cancel'} textColor="red" action={handleClose}/>
                    <Button  color="secondary" variant="contained" component="span" onClick={handleCreate}>
                        {updateMode ? 'Update' :  'Post'}
                    </Button>

                </DialogActions>
            </Dialog>
        </div>
    );
}
